import { render, staticRenderFns } from "./DetailPaymentReceipt.vue?vue&type=template&id=4da2342c&scoped=true&"
import script from "./DetailPaymentReceipt.vue?vue&type=script&lang=js&"
export * from "./DetailPaymentReceipt.vue?vue&type=script&lang=js&"
import style0 from "./DetailPaymentReceipt.vue?vue&type=style&index=0&id=4da2342c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da2342c",
  null
  
)

export default component.exports